import _ from "lodash";
import { environment } from "./environments/environment";
import { MEGABYTE } from "./domain/constants";

export const apiURL = environment.API_URL;
export const clientURL = environment.CLIENT_URL;
export const apiFilesURL = environment.API_FILES_URL;
export const projectEmail = environment.PROJECT_EMAIL;

export const telegramLink = environment.TELEGRAM;

export const maxFileSizeBytes = +_.get(
    environment,
    "MAX_FILE_SIZE_BYTES",
    2048
);
export const maxFilesSizeMb = maxFileSizeBytes / MEGABYTE;
export const prostirLink = environment.PROSTIR;
export const easypayLink = environment.EASYPAY;
export const mastercardLink = environment.MASTERCARD;
export const visaLink = environment.VISA;

export const workStartFromOffsetMin = +_.get(
    environment,
    "WORK_START_FROM_OFFSET_MIN",
    1
);
export const workConsideredNewTime = +_.get(
    environment,
    "WORK_CONSIDERED_NEW_TIME",
    12
);

export const contactsEmail = environment.CONTACTS_EMAIL;
export const contactsPhone = environment.CONTACTS_PHONE;

export const disableRecurrentPayments =
    environment.DISABLE_RECURRENT_PAYMENTS.toLowerCase() === "true";
